<template>
	<div class="view">
		<div class="form">
			<div class="title">Рука мастера</div>

			<div class="fields">
				<input type="text" v-model="name" placeholder="Имя">
				<the-mask type="tel" v-model="phone" placeholder="Телефон" mask="+7 ### ### ## ##"/>
				<input type="text" v-model="city" placeholder="Город">
				<!-- <div class="select">
					<div class="selected" @click="selecting = !selecting">{{ city }}</div>
					<div class="options" :class="{visible: selecting}">
						<div
							class="option"
							v-for="(option, index) in cities"
							:key="index"
							@click="select(option)"
						>{{ option }}</div>
					</div>
				</div>-->
			</div>

			<textarea class="comment" v-model="comment" placeholder="Ваш комментарий"/>
			<uiDevider class="devider"/>

			<div class="done" v-if="done">Спасибо, мы получили вашу анкету</div>
			<uiButton color="dark" :enabled="valid && !loading" @click="sendData" v-else>Хочу тату</uiButton>
		</div>
	</div>
</template>

<script>
import { TheMask } from 'vue-the-mask'
import axios from 'axios'

export default {
	name: 'Form',
	components: { TheMask },
	data() {
		return {
			loading: false,
			done: false,
			name: '',
			phone: '',
			comment: '',
			selecting: false,
			city: '',
			// city: 'Москва',
			cities: [
				'Москва',
				'Санкт-Петербург',
				'Казань',
			]
		}
	},
	computed: {
		phoneValid() {
			let phone = '+7' + this.phone
			return !!(phone.match(/^\+7[0-9]{10}$/))
		},
		nameValid() {
			let name = this.name.trim()
			return name.length > 1
		},
		cityValid() {
			let city = this.city.trim()
			return city.length > 1
		},
		commentValid() {
			let comment = this.comment.trim()
			return comment.length > 10
		},
		valid() {
			return this.nameValid && this.phoneValid && this.commentValid && this.cityValid
		}
	},
	methods: {
		select(city) {
			this.city = city
			this.selecting = false
		},
		async sendData() {
			
			if (!this.valid || this.done) return
			this.loading = true

			let payload = {
				name: this.name.trim(),
				phone: '+7' + this.phone,
				town: this.city.trim(),
				story: this.comment.trim(),
			}
			
			let { data } = await axios.post('/api.php', payload)
			this.loading = false
			
			if (data.created_at) {
				ga('send', 'event', 'form', 'sent')
				this.done = true
			}

		}
	}
}
</script>


<style lang="less" scoped>
@import "../styles.less";

.view {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-image: url(../assets/form-bg.jpg);
	background-size: cover;
}

.form {
	width: 96%;
	max-width: 700px;
	color: #000;
}

.title {
	font-size: 40px;
	font-weight: bold;
	margin-bottom: 30px;
	text-transform: uppercase;
	font-family: @font-title;
}

.fields {
	display: flex;
	justify-content: space-between;

	input {
		width: 100%;
		background: none;
		border: 1px solid #000;
		font-size: 16px;
		padding: 15px;
		margin-left: 20px;
		outline: none;
		color: #000;

		&::placeholder {
			color: #000;
		}

		&:first-child {
			margin-left: 0;
		}
	}
}

.select {
	width: 100%;
	margin-left: 20px;
	cursor: pointer;
	position: relative;

	.selected {
		width: 100%;
		background: none;
		border: 1px solid #000;
		font-size: 16px;
		padding: 15px;
		outline: none;
		color: #000;
	}

	.options {
		width: 100%;
		position: absolute;
		padding: 5px 15px;
		padding-bottom: 15px;
		background: @color-main;
		border: 1px solid #000;
		border-top: none;
		pointer-events: none;
		transition: opacity 200ms ease;
		opacity: 0;

		&.visible {
			pointer-events: all;
			opacity: 1;
		}

		.option {
			padding-top: 10px;
			opacity: 0.7;
			transition: opacity 300ms ease;

			&:hover {
				opacity: 1;
			}
		}
	}
}

.comment {
	width: calc(100% - 30px);
	min-height: 100px;
	padding: 15px;
	font-size: 16px;
	margin-top: 20px;
	background: none;
	outline: none;
	border: 1px solid #000;
	resize: none;

	&::placeholder {
		color: #000;
	}
}

.devider {
	margin: 30px 0;
}

.done {
	height: 58px;
	line-height: 58px;
}

@media (max-width: 900px) {
	.view {
		width: 100%;
		height: auto;
		min-height: 100vh;
		padding-bottom: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-image: url(../assets/form-bg.jpg);
		background-size: cover;
	}

	.title {
		margin-top: 100px;
	}
	.fields {
		display: flex;
		justify-content: space-between;
		flex-direction: column;

		input {
			width: calc(100% - 30px);
			background: none;
			border: 1px solid #000;
			font-size: 16px;
			padding: 15px;
			margin-left: 0px;
			margin-top: 10px;
			outline: none;
			color: #000;

			&::placeholder {
				color: #000;
			}

			&:first-child {
				margin-left: 0;
			}
		}
	}

	.devider {
		margin: 20px 0;
	}
}
</style>
